import React, { useRef, useEffect } from "react";
import "./Home.css";
import { OpenSeaDragonReact } from "../Components/OpenSeadragonReact";
import OpenSeadragon from "openseadragon";
import axios from "axios";
import ZoomIn from "../Assets/buttonPlus.svg";
import ZoomOut from "../Assets/buttonMinus.svg";
import Reset from "../Assets/buttonReset.svg";
import Logo from "../Assets/createdBY.svg";
import Nasa from "../Assets/imagesCourtesy.svg";
import * as WithTracker from "Shoothill.Core/Utils/App/WithGATracker";
import { sendEvent } from "Shoothill.Core/Utils/App/GoogleAnalyticsUtils";
import { Grid, Paper, Box, makeStyles, Typography } from "@material-ui/core";
import styled from "styled-components";
import {
	FacebookShareButton,
	LinkedinShareButton,
	TwitterShareButton,
	TelegramShareButton,
	WhatsappShareButton,
	PinterestShareButton,
	VKShareButton,
	OKShareButton,
	RedditShareButton,
	TumblrShareButton,
	LivejournalShareButton,
	FacebookIcon,
	FacebookShareCount,
	TwitterIcon,
	WhatsappIcon,
	LinkedinIcon,
	PinterestIcon
} from "react-share";
const useStyles = makeStyles(theme => ({
	root: {
		// width: "100%",
		// maxWidth: 500
		flexGrow: 1
	},
	button: {
		margin: theme.spacing(1)
	},
	input: {
		display: "none"
	},
	paper: {
		padding: theme.spacing(2),
		textAlign: "center",
		color: theme.palette.text.secondary
	}
}));

export const PaperFullHeight = styled(Paper)`
	height: 90vh;
	padding-left: 10px;
`;

export const LinkBox = styled(Box)`
	padding: 5px;
	cursor: pointer;
`;

export const FancyBox = styled(Box)`
	display: inline-block;
	padding: 10px;
	transition: background-color 0.5s ease-in-out;
	&:hover {
		background-color: #f2893e;
		/* animation: color 4s ease-in-out; */
	}
`;

export const RightSide = styled(Grid)`
	overflow: auto;
	height: 90vh;
`;

export const ButtonGroup = styled(Box)`
	position: absolute;
	top: 0px;
	left: 0px;
	z-index: 1000;
	max-width: 250px;
	cursor: pointer;
	@media (max-width: 900px) {
		padding-top: 15px;
		padding-left: 20px;
	}
`;

export const ImgButton = styled.img`
	padding-right: 15px;
	width: 40px;
	@media (min-width: 600px) {
		width: 50px;
	}
`;

export const OneSmallStep = styled(Box)`
	text-transform: uppercase;
	position: absolute;
	top: 0px;
	right: 0px;
	z-index: 1000;
	padding-right: 20px;
	padding-top: 15px;
	width: 150px;
	color: white;
	user-select: none;
	align-items: flex-end;
	p {
		font-size: 10px;
	}
	@media (min-width: 400px) {
		padding-right: 20px;
		width: 200px;
		p {
			font-size: 12px;
		}
	}
	@media (min-width: 640px) {
		padding-right: 20px;
		width: 400px;
		p {
			font-size: 14px;
		}
	}
	@media (min-width: 950px) {
		font-size: 18px;
		width: auto;
		padding-top: 50px;
		padding-right: 80px;
		p {
			font-family: "Gotham";
		}
	}
`;
export const OneSmallStepBold = styled.span`
	font-family: "GothamBold";
`;

export const LogoBox = styled(Box)`
	position: absolute;
	z-index: 1000;
	bottom: 0px;
	right: 0px;
	padding-bottom: 57px;
	padding-right: 80px;
	cursor: pointer;
	@media (max-width: 600px) {
		padding-bottom: 10px;
		padding-right: 40px;
		img {
			width: 100px;
		}
	}
`;

export const Attribution = styled(Box)`
	position: absolute;
	left: 0px;
	bottom: 0px;
	padding-bottom: 10px;
	padding-left: 10px;
	z-index: 1000;
	@media (min-width: 600px) {
		padding-bottom: 50px;
		padding-left: 100px;
	}
	@media (max-width: 600px) {
		img {
			width: 150px;
		}
	}
`;

export const NetworkShares = styled(Box)`
	vertical-align: top;
	display: flex;
	margin-right: 15px;
	text-align: center;
	div {
		padding-right: 6px;
		cursor: pointer;
	}
`;

export var infoIcon: any;
export var square: any;
export var apollo11: any;

export const Home: React.FC = () => {
	//const classes = useStyles();
	var openSeaDragonRef: any = useRef();
	let viewPort: OpenSeadragon.Viewport;
	//const showIconAtZoomLevel = 1.5;
	const dzUrl = "https://deepzoom01.blob.core.windows.net/apollo11-50k/output.xml";
	const dzWidth = 945918.5509784536;
	const dzHeight = 944951.33241448808;
	const aspectRatio = dzWidth / dzHeight;
	//const cellWidth = 0.0044913413798331348;
	//const cellHeight = 0.0044913413798331348;

	//const getLogicalWidth = (x: number) => dzWidth / x / 1000;
	//const getLogicalHeight = (y: number) => dzHeight / y / 1000;

	const getViewer = (): OpenSeadragon.Viewer => {
		return openSeaDragonRef.current.viewer as OpenSeadragon.Viewer;
	};

	useEffect(() => {
		// viewPort = openSeaDragonRef.current.viewer.viewport;
		// infoIcon = document.createElement("img");
		// infoIcon.id = "apollo11";
		// infoIcon.src = "https://deepzoom01.blob.core.windows.net/apollo11-50k/apollo11.png";
		// openSeaDragonRef.current.addElement({
		// 	id: "apollo11",
		// 	element: infoIcon,
		// 	x: 0,
		// 	y: 0,
		// 	width: 512,
		// 	height: 512
		// });
		// square = document.createElement("div");
		// square.addEventListener("mouseover", onIconHover);
		// square.id = "square";
		// square.src = "https://deepzoom01.blob.core.windows.net/apollo11-50k/information.png";
		// square.className = "highlight";
		// let width = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(0.0309, 0.0305);
		// openSeaDragonRef.current.addElement({
		// 	id: "square",
		// 	element: square,
		// 	x: 0,
		// 	y: 0,
		// 	width: 4079,
		// 	height: 4026
		// });
	}, []);

	const onIconHover = () => {
		console.log("Icon hover");
	};

	const onClick = () => {
		viewPort = openSeaDragonRef.current.viewer.viewport;
		let width = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(0.0309, 0.0305);
		console.log(viewPort.getBoundsWithMargins());
		//viewPort.zoomBy(2);
		let rect = new OpenSeadragon.Rect(0, 0, 1, 1);
		//getViewer().viewport.fitBounds(new OpenSeadragon.Rect(0, 0, 0.03, 0.03));
		openSeaDragonRef.current.withSlowOSDAnimation(getViewer().viewport, function() {
			// stuff
			getViewer().viewport.fitBounds(new OpenSeadragon.Rect(0.5, 0.8, 0.0044913413798331348, 0.0044913413798331348));
		});
		//viewPort.fitBounds(rect);
		//infoIcon.style.display = "none";
	};

	const onMouseMove = async (mouseEvent: any) => {
		return;
		console.log(mouseEvent.position.x, mouseEvent.position.y);
		//return;
		var vp = getViewer().viewport.pointFromPixel(mouseEvent.position);
		if (vp.x < 0 || vp.x > 1 || vp.y < 0 || vp.y > aspectRatio * 1.1) return;

		//EN: Use the following if all the cells are of equal height and width to save making a call back to the server
		// {
		// 	let xx = Math.floor(vp.x / cellWidth) * cellWidth;
		// 	let yy = Math.floor(vp.y / cellHeight) * cellHeight;
		// 	var size = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(cellWidth, cellHeight);
		// 	var xy = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(xx, yy);
		// }

		//EN: Make a call to the server to get actual dimensions of the cell
		var data = await axios.get(`/api/deepzoom/getcell/${vp.x}/${vp.y}`);
		if (data.data === "") return;
		var size = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(
			data.data.logicalRect.w,
			data.data.logicalRect.h
		);
		var xy = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(
			data.data.logicalRect.x,
			data.data.logicalRect.y
		);
		console.log(data.data.fileName, data.data.cell.x, data.data.cell.y);
		return;
		let e = openSeaDragonRef.current.getElementById("square");
		e.x = xy.x;
		e.y = xy.y;
		e.width = size.x;
		e.height = size.y;
		e.rect = new OpenSeadragon.Rect(e.x + e.width / 2, e.y + e.height / 2, e.width, e.height);
		openSeaDragonRef.current.repositionElement(e, openSeaDragonRef.current.viewer);
	};

	const onZoom = (viewer: OpenSeadragon.Viewer) => {
		//zoomLevel > showIconAtZoomLevel ? (infoIcon.style.display = "block") : (infoIcon.style.display = "none");
		let zoomLevel = (viewer.viewport as any)._oldZoom;
		if (apollo11) {
			apollo11.style.opacity = zoomLevel / 10;
			//console.log("Zoom=>" + zoomLevel, apollo11.style.opacity);
		}
	};

	const onOpen = (viewer: OpenSeadragon.Viewer) => {
		viewPort = openSeaDragonRef.current.viewer.viewport;
		var size = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(
			0.0043027400249884273,
			0.0044983191170333559
		);
		var xy = openSeaDragonRef.current.viewer.viewport.viewportToImageCoordinates(
			0.50450534470149666,
			0.42524071963078131
		);

		apollo11 = document.createElement("img");
		apollo11.id = "apollo11";
		apollo11.src = "https://deepzoom01.blob.core.windows.net/apollo11-50k/apollo11.jpg";
		//apollo11.style.display = "none";
		openSeaDragonRef.current.addElement({
			id: "apollo11",
			element: apollo11,
			x: xy.x,
			y: xy.y,
			width: size.x,
			height: size.y
		});
		//let e = openSeaDragonRef.current.getElementById("apollo11");
		//openSeaDragonRef.current.repositionElement(e, openSeaDragonRef.current.viewer);

		getViewer().viewport.fitBounds(
			new OpenSeadragon.Rect(0.50450534470149666, 0.42524071963078131, 0.0043027400249884273, 0.0044983191170333559),
			true
		);
		setTimeout(() => {
			apollo11.style.display = "block";
			openSeaDragonRef.current.withSlowOSDAnimation(getViewer().viewport, function() {
				// getViewer().viewport.fitBounds(
				// 	new OpenSeadragon.Rect(0.50450534470149666, 0.42524071963078131, 0.0043027400249884273, 0.0044983191170333559)
				// );
				getViewer().viewport.goHome();
			});
		}, 2500);
		console.log("Opened");
	};

	return (
		<>
			<ButtonGroup maxWidth="" paddingLeft={"100px"} paddingTop={"30px"}>
				<div style={{ float: "left" }}>
					<ImgButton src={ZoomIn} id="zoom-in" />
				</div>
				<div style={{ float: "left" }}>
					<ImgButton src={ZoomOut} id="zoom-out" />
				</div>
				<div style={{ float: "left" }}>
					<ImgButton src={Reset} id="reset" />
				</div>

				{/* <Button onClick={onClick}>Click</Button> */}
			</ButtonGroup>

			<OneSmallStep>
				<Box display="flex">
					<Typography align="right">
						One small step for man, one giant leap for mankind&nbsp;<OneSmallStepBold>20th July 1969</OneSmallStepBold>
					</Typography>
				</Box>
			</OneSmallStep>
			<LogoBox>
				<img
					src={Logo}
					onClick={() => {
						sendEvent({ action: "clicked", category: "logo" });
						window.open("https://www.shoothill.com", "_blank");
					}}
				/>
			</LogoBox>
			<Attribution>
				<img src={Nasa} />
				<Box>
					{!(window as any).iniFrame && (
						<div style={{ float: "left" }}>
							<FBShare />
						</div>
					)}
				</Box>
			</Attribution>
			<div id="openseadragon">
				<OpenSeaDragonReact
					showNavigator={false}
					onOpen={onOpen}
					onZoom={onZoom}
					onMouseMove={onMouseMove}
					ref={openSeaDragonRef}
					image={dzUrl}
				/>
			</div>
		</>
	);
};

export const FBShare = React.memo(() => {
	const shareUrl = "https://apollo11.shoothill.com";
	const title = "Shoothill - Apollo 11 moon landing 50th anniversary megafiche";
	const iconSize = 38;
	return (
		<NetworkShares>
			<FacebookShareButton
				url={shareUrl}
				quote={title}
				onShareWindowClose={() => sendEvent({ action: "clicked", category: "facebook" })}>
				<FacebookIcon size={iconSize} round />
			</FacebookShareButton>
			<TwitterShareButton
				url={shareUrl}
				title={title}
				onShareWindowClose={() => sendEvent({ action: "clicked", category: "twitter" })}>
				<TwitterIcon size={iconSize} round />
			</TwitterShareButton>
			<WhatsappShareButton
				url={shareUrl}
				title={title}
				separator=":: "
				onShareWindowClose={() => sendEvent({ action: "clicked", category: "whatsapp" })}>
				<WhatsappIcon size={iconSize} round />
			</WhatsappShareButton>
			<LinkedinShareButton
				url={shareUrl}
				windowWidth={750}
				windowHeight={600}
				onShareWindowClose={() => sendEvent({ action: "clicked", category: "linkedin" })}>
				<LinkedinIcon size={iconSize} round />
			</LinkedinShareButton>
			{/* <PinterestShareButton
				url={String(window.location)}
				media={`${String(window.location)}`}
				windowWidth={1000}
				windowHeight={730}
				onShareWindowClose={() => sendEvent({ action: "clicked", category: "pinterest" })}>
				>
				<PinterestIcon size={iconSize} round />
			</PinterestShareButton> */}
		</NetworkShares>
	);
});

export const HomeContainer = WithTracker.withTracker(Home);
